module.exports = __webpack_public_path__ + "img/kachel-ERSCHOEPFUNG_MINDMASERGREEN.fa8d5c8e.png";